<template>
  <div class="mobile-more-menu">
    <p v-if="unsynced" class="mobile-more-status">未同步</p>
    <ul class="mobile-more-list">
      <li>
        <button type="button" data-bs-toggle="modal" data-bs-target="#RecurrentEventsModal">
          <i class="bi-arrow-repeat"></i>
          <span>{{ $t("ui.recurringTasks") }}</span>
          <i class="bi-chevron-right mobile-more-chevron" aria-hidden="true"></i>
        </button>
      </li>
      <li>
        <button type="button" data-bs-toggle="modal" data-bs-target="#configModal">
          <i class="bi-gear"></i>
          <span>{{ $t("settings.settings") }}</span>
          <i class="bi-chevron-right mobile-more-chevron" aria-hidden="true"></i>
        </button>
      </li>
      <li>
        <button type="button" data-bs-toggle="modal" data-bs-target="#tipsModal">
          <i class="bi-info-square"></i>
          <span>{{ $t("tips.tips") }}</span>
        </button>
      </li>
      <li>
        <button type="button" data-bs-toggle="modal" data-bs-target="#dateRangeExportModal">
          <i class="bi-download"></i>
          <span>{{ $t("ui.exportByDate") }}</span>
          <i class="bi-chevron-right mobile-more-chevron" aria-hidden="true"></i>
        </button>
      </li>
      <li v-if="isAdmin">
        <button type="button" @click="$emit('open-admin')">
          <i class="bi-shield-lock"></i>
          <span>{{ $t("ui.admin") }}</span>
          <i class="bi-chevron-right mobile-more-chevron" aria-hidden="true"></i>
        </button>
      </li>
      <li>
        <button type="button" data-bs-toggle="modal" data-bs-target="#profileModal">
          <i class="bi-person"></i>
          <span>{{ $t("ui.profile") }}</span>
          <i class="bi-chevron-right mobile-more-chevron" aria-hidden="true"></i>
        </button>
      </li>
    </ul>
    <p v-if="appVersion" class="mobile-more-version" aria-label="version">
      {{ $t("settings.version") }} {{ appVersion }}
    </p>
  </div>
</template>

<script>
const { loadMeta } = require("../sync/cache");

export default {
  name: "MobileMoreMenu",
  emits: ["open-admin"],
  props: {
    isAdmin: {
      type: Boolean,
      default: false,
    },
    appVersion: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      unsynced: false,
    };
  },
  mounted() {
    this.refreshUnsynced();
    this._onSyncStatus = (event) => {
      if (event.detail && typeof event.detail.pending === "boolean") {
        this.unsynced = event.detail.pending;
        return;
      }
      this.refreshUnsynced();
    };
    window.addEventListener("sync-status", this._onSyncStatus);
  },
  beforeUnmount() {
    window.removeEventListener("sync-status", this._onSyncStatus);
  },
  methods: {
    refreshUnsynced() {
      const meta = loadMeta();
      const docs = meta.docs || {};
      this.unsynced =
        Object.keys(docs).some((key) => docs[key] && docs[key].dirty) || (meta.deletes || []).length > 0;
    },
  },
};
</script>

<style scoped>
.mobile-more-menu {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: 16px 16px 28px;
  background: var(--m-page, #f2f2f7);
}

.mobile-more-list {
  list-style: none;
  margin: 0;
  padding: 0;
  border-radius: var(--m-radius, 12px);
  overflow: hidden;
  background: var(--m-surface, #fff);
  box-shadow: none;
}

.mobile-more-list li + li button {
  border-top: 1px solid var(--m-hairline, rgba(60, 60, 67, 0.18));
}

.mobile-more-list button {
  display: flex;
  align-items: center;
  gap: 14px;
  width: 100%;
  border: none;
  background: transparent;
  color: inherit;
  text-align: start;
  font-size: var(--m-text, 17px);
  font-weight: 400;
  letter-spacing: -0.01em;
  padding: 14px 16px;
  min-height: 52px;
  cursor: pointer;
}

.mobile-more-list button:active {
  background: rgba(120, 120, 128, 0.12);
}

.mobile-more-list button > span {
  flex: 1;
  min-width: 0;
}

.mobile-more-list button > i:first-child {
  font-size: 1.25rem;
  width: 1.5rem;
  text-align: center;
  color: #0d6efd;
}

.dark-theme .mobile-more-list button > i:first-child {
  color: #0a84ff;
}

.mobile-more-chevron {
  font-size: 0.95rem;
  width: auto !important;
  opacity: 0.28;
}

.mobile-more-status {
  list-style: none;
  margin: 0 0 12px;
  padding: 10px 14px;
  border-radius: 10px;
  font-size: var(--m-caption, 13px);
  font-weight: 500;
  color: #b54708;
  background: rgba(255, 159, 10, 0.14);
}

.mobile-more-version {
  margin: 28px 0 8px;
  padding: 0 4px;
  text-align: center;
  font-size: var(--m-caption, 13px);
  font-weight: 400;
  letter-spacing: 0.02em;
  color: var(--m-muted, rgba(60, 60, 67, 0.55));
  user-select: text;
  -webkit-user-select: text;
}
</style>
